/**
 * airan-ntn — Energy Harvest xApp
 * Manages satellite energy during eclipse and battery-critical periods
 */

import { XAppBase } from './XAppBase.js';
import { E2KpmReport, E2RcAction, XAppDecision } from '../types.js';

export class EnergyHarvestXApp extends XAppBase {
  private lastReports: Map<number, E2KpmReport> = new Map();

  constructor(enabled: boolean = true) {
    super('energy-harvest', enabled);
  }

  processKpmReport(report: E2KpmReport): void {
    this.lastReports.set(report.gnbId, report);
  }

  decisionCycle(): XAppDecision {
    const start = performance.now();
    const actions: E2RcAction[] = [];

    for (const [gnbId, report] of this.lastReports) {
      if (report.batterySoc < 0.2 || report.solarPower < 50) {
        actions.push({
          type: 'BEAM_SHUTDOWN',
          targetId: gnbId,
          payload: { beams: [0, 1], reason: 'energy_conservation' },
          priority: this.config.priority,
          timestamp: Date.now()
        });
        actions.push({
          type: 'COMPUTE_THROTTLE',
          targetId: gnbId,
          payload: { throttlePercent: 50 },
          priority: this.config.priority,
          timestamp: Date.now()
        });
      }
    }

    const latency = performance.now() - start;
    this.recordDecision(latency);

    return { actions, confidence: 0.95, latencyMs: latency };
  }

  getRequiredSubscription(): { eventTriggers: string[]; reportStyle: string } {
    return {
      eventTriggers: this.config.requiredEventTriggers,
      reportStyle: this.config.requiredReportStyle
    };
  }
}